<template>
  <div
    class="modal fade"
    id="shared-modal"
    ref="sharedModal"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
    data-test="shared-modal"
    :data-backdrop="modalData.status.preventHide ? 'static' : null"
    :data-keyboard="modalData.status.preventHide"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="mb-0 mt-1" data-test="shared-modal-title">{{ modalData.texts.title }}</h5>
          <button type="button" class="close cirx-custom-primary-on-hover" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" :class="bodyClass" data-test="shared-modal-body">
          {{ modalData.texts.content }}
        </div>
        <div class="modal-footer design-system" :class="footerClass">
          <CxButton variant="outline-light" @click="onCancel" data-test="shared-modal-cancel-btn">
            {{ modalData.texts.cancelLabel }}
          </CxButton>

          <BrandedButton :style="cssVars" @click="onConfirm" data-test="shared-modal-confirm-btn">
            {{ modalData.texts.confirmLabel }}
          </BrandedButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrandedButton from "@/apps/shared/buyback/view/components/Button/BrandedButton.vue";
import { CxButton } from "@/designSystem";
import useModalStore from "@/core/store/layout/modalStore";
import { customCssVarsMixin } from "@/view/mixins/customCssVarsMixin";
import jQuery from "jquery";
import { storeToRefs } from "pinia";
import { computed, onMounted, ref } from "vue";

export default {
  name: "SharedModal",

  mixins: [customCssVarsMixin],

  components: {
    BrandedButton,
    CxButton,
  },

  setup() {
    const sharedModal = ref();
    const modalStore = useModalStore();
    const { modalData } = storeToRefs(modalStore);

    onMounted(() => {
      jQuery(sharedModal).on("hidden.bs.modal", () => {
        if (!modalData.value.status?.preventHide) {
          modalStore.resetModalStatus();
        }
      });
    });
    const onCancel = () => {
      modalData.value.functions?.cancelFunction();
      modalStore.resetModalStatus();
    };
    const onConfirm = () => {
      modalData.value.functions?.confirmFunction();
      modalStore.resetModalStatus();
    };
    const bodyClass = computed(() => (!modalData.value.texts?.content ? "d-none" : ""));

    const footerClass = computed(() => (!modalData.value.texts?.content ? "border-0" : ""));
    return { modalData, onCancel, onConfirm, bodyClass, footerClass };
  },
};
</script>
